<template>
	<Observer @on-change="onSectionVisible" :threshold="0.5">
		<VueAgile
			ref="carousel"
			:dots="!isCarouselDisabled"
			:autoplay="false"
			:nav-buttons="false"
			:unagile="isCarouselDisabled"
			:center-mode="centerMode"
			:slides-to-show="slidesToShow"
			:infinite="infinite"
			@after-change="onSlideChanged"
			@before-change="onBeforeChange"
		>
			<template v-for="slide in slides">
				<slot :slide="slide" />
			</template>
		</VueAgile>
	</Observer>
</template>

<script>
import { VueAgile } from 'vue-agile'
import Observer from 'vue-intersection-observer'

import Jet, { typeLong } from '@/modules/Jet'

export default {
	name: 'Carousel',

	components: { Observer, VueAgile },

	props: {
		slides: {
			type: Array,
			required: true,
		},

		analyticsContentType: {
			type: String,
			required: true,
		},

		analyticsPlacement: {
			type: String,
			required: true,
		},

		centerMode: {
			type: Boolean,
			default: false,
		},

		slidesToShow: {
			type: Number,
			default: 1,
		},

		infinite: {
			type: Boolean,
			default: true,
		},
	},

	emits: ['afterChange', 'beforeChange'],

	data: () => ({
		analyticsAlreadySentEvents: new Set(),
		touchStartX: null,
		touchStartY: null,
		scrollTarget: null,
		scrollTop: null,
	}),

	computed: {
		currentSlide() {
			let currentSlideIndex = this.$refs.carousel.getCurrentSlide()

			if (this.isCarouselDisabled) {
				currentSlideIndex = 0
			}

			return {
				index: currentSlideIndex + 1,
				data: this.slides[currentSlideIndex],
			}
		},

		isCarouselDisabled() {
			return this.slides.length < 2
		},
	},

	created() {
		if (this.isCarouselDisabled) {
			this.$emit('afterChange', 0)
		}
	},

	methods: {
		sendAnalyticsEvent() {
			if (this.analyticsAlreadySentEvents.has(this.currentSlide.index)) {
				return
			}

			this.$analytic.logEvent('CarouselStepReach', {
				placement: this.analyticsPlacement,
				content_type: this.analyticsContentType,
				content: this.currentSlide.data.id,
				step: this.currentSlide.index,
			})
			Jet.logUxEvent('CarouselStepReach', {
				placement: this.analyticsPlacement,
				contentType: this.analyticsContentType,
				content: this.currentSlide.data.id,
				step: typeLong(this.currentSlide.index),
			})

			this.analyticsAlreadySentEvents.add(this.currentSlide.index)
		},

		onSectionVisible(entry, unobserve) {
			if (!entry.isIntersecting) {
				return
			}

			this.sendAnalyticsEvent()

			unobserve()
		},

		onSlideChanged({ currentSlide }) {
			this.$emit('afterChange', currentSlide)

			if (currentSlide > 0) {
				this.sendAnalyticsEvent()
			}
		},

		onBeforeChange(event) {
			this.$emit('beforeChange', event)
		},
	},
}
</script>
